import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import HomeComponent from './HomeComponent';
import AboutPage from './about';
import ErrorPage from './error';
import StreamComponent from './StreamComponent';
import AuthSuccess from './AuthSuccess';
import LoginPage from './LoginPage';

// UI review page (#101): only exists under `npm start`. NODE_ENV is fixed at build time, so production
// builds drop this branch and the page's code entirely.
const UIReview = process.env.NODE_ENV === 'development' ? React.lazy(() => import('./dev/UIReview')) : null;

const RoutesConfig = ({ channelData }) => {
  return (
    <Routes>
      <Route path="/" element={<HomeComponent />} />
      <Route path="/about-multistream-viewer-twitch-youtube-kick" element={<AboutPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/error" element={<ErrorPage />} />
      <Route path="/auth-success" element={<AuthSuccess />} />
      {UIReview && <Route path="/dev/ui" element={<Suspense fallback={null}><UIReview /></Suspense>} />}
      <Route
        path="/:usernames/*"
        element={<StreamComponent channelData={channelData} />}
      />
    </Routes>
  );
};

export default RoutesConfig;